import ExperienceHostAvatars from 'components/ExperienceItem/ExperienceHostAvatars';
import ImageComponent from 'components/Image';
import React from 'react';

const CSS = require('./TopSearchCardHostAvatar.less');

const AVATAR_SIZE = 48;
const avatarOptions = { width: AVATAR_SIZE, height: AVATAR_SIZE };

export default function ({ experience, hosts }) {
  if (hosts.length > 1) {
    return <ExperienceHostAvatars hosts={hosts} />;
  }
  const photo =
    experience.is_originals && hosts.length > 0
      ? hosts[0].photo
      : experience.account.photo;
  return (
    <ImageComponent
      animate
      width={AVATAR_SIZE}
      height={AVATAR_SIZE}
      className={CSS.hostAvatar}
      src={photo}
      options={avatarOptions}
      loading="lazy"
      imporance="low"
    />
  );
}
